import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthenticatorService } from '@aws-amplify/ui-angular';

@Component({
  selector: 'nem-root',
  template: `
    @if (authenticated) {
    <p-messages></p-messages>
    <nem-top-menu></nem-top-menu>
    }
    <router-outlet></router-outlet>
  `,
  standalone: false
})
export class AppComponent {
  @HostBinding('class') classname = 'h-full';

  constructor(private _authenticator: AuthenticatorService) {}

  get authenticated() {
    return this._authenticator.authStatus == 'authenticated';
  }
}
